import { ITileCacheSeeder } from "../Features/MapComponents/TileCache/types";
import { ISettings } from "./settingsTypes";

export const copySettings = (value: ISettings): ISettings => {
    return { 
        ...value,
        map: {...value.map}, 
        tileCache: {...value.tileCache}, 
        ui: {...value.ui}
    };
};

export const normaliseSettings = (data: ISettings, defaults: ISettings, cacheSeeders: ITileCacheSeeder[]): ISettings => {
        
    data.ui.headingUnit = data.ui.headingUnit ?? defaults.ui.headingUnit;
    data.ui.distanceUnits = data.ui.distanceUnits ?? defaults.ui.distanceUnits;

    const activeSeeder = 
        cacheSeeders.find(cs => cs.id === data.tileCache.activeCacheSeederId && cs.isSupported() === true) 
        ?? cacheSeeders.find(cs => cs.isSupported() === true) 
        ?? null;

    data.tileCache.activeCacheSeederId = activeSeeder?.id;

    return data;
};